import React, { useCallback } from 'react'
import { Paper } from '@mui/material'
import { TableComplete } from '@e3dc-react/shell/Elements/Table'
import { ChargingCardModel } from '../api/models/charging-card-model'
import { useTableStyles } from '../../shared/styles/table.styles'
import { updateChargingCardsSort } from 'src/State/E-Mobility/EMobilityStateAction'
import { useDispatch } from 'react-redux'
import { useTypedSelector } from 'src/State/RootReducer'
import { useChargingCardsTableHeader } from '../hooks/useChargingCardsTableHeader'
import useModals from 'src/Hooks/useModals'

interface ChargingCardsTableDesktopViewProps {
  chargingCards: ChargingCardModel[]
  installationId: number
  installationHasWallboxes: boolean
}

/** Component shows charging cards data in table view for desktop */
export const ChargingCardsTableDesktopView: React.FC<ChargingCardsTableDesktopViewProps> = ({
  chargingCards,
  installationId,
  installationHasWallboxes,
}) => {
  const { classes } = useTableStyles()

  const dispatch = useDispatch()
  const chargingCardsSort = useTypedSelector(state => state.eMobility.chargingCardsTable.sort)
  const isManagedMode = chargingCards.some(card => card.linkedWallboxes.length > 0)

  const chargingCardsTableHeader = useChargingCardsTableHeader({ installationId, isManagedMode })
  const { openChargingCardDetailsDialog } = useModals()

  const onRowClick = useCallback(
    (row: ChargingCardModel) => {
      openChargingCardDetailsDialog({ chargingCard: row, installationId, isManagedMode, installationHasWallboxes })
    },
    [installationHasWallboxes, installationId, isManagedMode, openChargingCardDetailsDialog]
  )

  return (
    <Paper className={classes.tableContainer}>
      <TableComplete
        header={chargingCardsTableHeader}
        data={chargingCards}
        bodyElevation={0}
        footerElevation={0}
        headerElevation={0}
        rowClassName={classes.row}
        className={classes.table}
        headerClassName={classes.tableHeader}
        coloredColumn
        onSortChange={sort => dispatch(updateChargingCardsSort(sort))}
        initialSort={chargingCardsSort && { direction: chargingCardsSort.direction, name: chargingCardsSort.name }}
        onSelect={onRowClick}
      />
    </Paper>
  )
}
